import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedDocumentsComponent } from '../common-liability/documents/documents.component';
import { DataTablesModule } from 'angular-datatables';
import { GridModule } from '@tmhcc-ng-lib/framwork/grid';

@NgModule({
  declarations: [SharedDocumentsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    DataTablesModule.forRoot()
  ],
  exports: [SharedDocumentsComponent]
})
export class SharedDocumentsModule {}
